import { Skeleton } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { useQuery } from "@tanstack/react-query";
import MUIDataTable,{ MUIDataTableOptions } from "mui-datatables";
import { useTranslation } from "react-i18next";
import AttToken from "../../helpers/attToken";
import Tickets from "../../service/Tickets";
import { getTicketStatusPresentation } from "../../helpers/ticketStatusPresentation";
import { getMuiTheme,tableOptions } from "../TableHelpers/options";
import { StyledDiv } from "../TableHelpers/TableStyle";

const ticketsService = new Tickets();

export default function AllTickets() {
  const { t } = useTranslation('translation');

  const response = useQuery({
    queryKey: ['GET_ALL_TICKETS_GESTOR'],
    queryFn: async () => {
      try {
        const token = await AttToken();
        if (!token) throw new Error('Token not found');
        const response = await ticketsService.getAllGestor(token);
        if (!response || !response.todosChamados) throw new Error('No tickets found');
        return response.todosChamados;
      } catch (err) {
        console.error(err);
      }
    }
  });

  const translatedTextLabels: MUIDataTableOptions = {
    textLabels: {
      body: {
        noMatch: `${t('table.noMatch')}`,
        toolTip: `${t('table.toolTip')}`,
        columnHeaderTooltip: column =>
          `${t('table.columnHeaderTooltip')} ${column.label}`
      },
      pagination: {
        next: `${t('table.next')}`,
        previous: `${t('table.previous')}`,
        rowsPerPage: `${t('table.rowsPerPage')}`,
        displayRows: `${t('table.displayRows')}`
      },
      toolbar: {
        search: `${t('table.search')}`,
        filterTable: `${t('table.filterTable')}`,
        viewColumns: 'Mostrar/Ocultar colunas'
      },
      filter: {
        title: `${t('table.title')}`,
        reset: `${t('table.reset')}`,
      },
      viewColumns: {
        title: `${t('table.viewColumnsTitle')}`,
      }
    }
  };

  const columns = [
    {
      name: "inicio",
      label: t('notifications.ticket.createdAt'),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value: number) => (
          new Date(value).toLocaleString('pt-BR')
        ),
      }
    },
    {
      name: 'usuarioNome',
      label: t('notifications.unread.user'),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value: string) => (
          value.startsWith('anonimo') ? `${t('notifications.ticket.anonymous')}` :
            value
        ),
      }
    },
    {
      name: 'nome',
      label: t('notifications.ticket.tickets'),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
      }
    },
    {
      name: "dataPrevisao",
      label: t('notifications.ticket.limitDate'),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value: number) => (
          value ?
            new Date(value).toLocaleString('pt-BR') : ''
        ),
      }
    },
    {
      name: "status",
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value: string) => {
          const presentation = getTicketStatusPresentation(value);
          return presentation ? <span className={presentation.tagClassName}>{t(presentation.labelKey)}</span> : <span>{value || '-'}</span>;
        }
      }
    },
  ];

  return (
    <StyledDiv>
      {response.isLoading || response.isFetching
        ? <Skeleton variant="rounded" width='100%' height={450} />
        : <ThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title={t('notifications.all.allcalls')}
            data={response.data}
            columns={columns}
            options={{ ...tableOptions, ...translatedTextLabels }}
          />
        </ThemeProvider>}
    </StyledDiv>
  );
}
